import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  background-color: #fff;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #fff;
`;

export const Section = styled.section`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 90px 8vw;
  background-color: ${({ tinted }) => (tinted ? "#f5fbfa" : "#fff")};

  @media (max-width: 768px) {
    padding: 60px 6vw;
  }
`;

export const SectionInner = styled.div`
  width: 100%;
  max-width: 1280px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
